
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/profile/calendar",
      function () {
        return require("private-next-pages/profile/calendar/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/profile/calendar"])
      });
    }
  